<template>
  <div class="public-layout">
    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm" style="padding: 25px 0px;">
      <div class="container">
        <img class="img-fluid" src="/logo.svg">

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav me-auto" style="margin: 0 auto;">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">About Us</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/our-fellows">Our Fellows</router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                Get Involved
              </a>
              <ul class="dropdown-menu" style="padding: 5px 15px; width: 20rem;">
                <li><router-link class="nav-link" to="/network-of-excellence">Network of Excellences</router-link></li>
                <li><router-link class="nav-link" to="/funding-and-training">Funding & Training
                    Opportunities</router-link></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                Media Centre
              </a>
              <ul class="dropdown-menu" style="padding: 5px 15px; width: 20rem;">
                <li><router-link class="nav-link" to="/public-news">News</router-link></li>
                <li><router-link class="nav-link" to="/public-gallery">Video and Photo Gallery</router-link></li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/contact">Contact Us</router-link>
            </li>
          </ul>

          <img class="img-fluid navbar-eu-logo" src="/EU logo.png" alt="European Union logo">

          <ul class="navbar-nav">
            <li class="nav-item" v-if="!isAuthenticated">
              <button class="btn btn-link nav-link" @click="showLoginModal = true"
                style="border-radius: 8px; background: #AD122A; color: #fff !important;padding: 15px 30px;">
                Login
              </button>
            </li>
            <li class="nav-item" v-if="isAuthenticated">
              <router-link class="nav-link" to="/my-profile" style="color: #fff !important;background: #009CAD;
              padding: 15px 30px;
              border-radius: 8px;">Dashboard</router-link>
            </li>
            <li class="nav-item" v-if="isAuthenticated">
              <button class="btn btn-link nav-link" @click="handleLogout"
                style="border-radius: 8px; background: #AD122A; color: #fff !important;padding: 15px 30px;">
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="footer-section bg-dark text-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 mb-4">
            <h5><strong>EDCTP</strong></h5>
            <p class="small mb-3" style="font-size: var(--font-size-lg);">
              The second EDCTP programme is supported under Horizon 2020, the European Union's Framework Programme for
              Research & Innovation.
            </p>
            <p class="small">www.edctp.org</p>
            <div class="footer-logo mt-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                <g clip-path="url(#clip0_252_27546)">
                  <path
                    d="M47.9034 22.4334C47.555 22.1907 47.2204 22.0378 47.5797 21.5632C47.7307 21.3638 47.4464 21.2711 47.2688 21.2859C46.2127 21.3747 45.1664 21.2287 44.1162 21.1823C43.9889 21.1764 43.8596 21.2148 43.7303 21.2316C43.444 21.2671 43.146 21.3816 42.9091 21.0974C42.835 21.0086 42.6998 21.0155 42.6327 21.054C41.9092 21.4714 41.2637 21.0441 40.5777 20.9188C39.9549 20.8054 39.3094 20.835 38.6895 20.6425C38.3095 20.5241 38.1338 20.9938 37.7676 21.0303C37.4182 21.0658 37.0975 21.2356 36.7323 21.0254C36.5052 20.8951 36.3523 21.054 36.3611 21.3066C36.3848 21.9677 36.3503 22.6308 36.372 23.2929C36.3898 23.8316 36.5013 24.4187 36.3068 24.9713C36.2072 25.2545 36.2496 25.5574 36.2575 25.8534C36.2614 26.0073 36.296 26.1761 36.4381 26.2382C37.4113 26.6655 37.131 27.5269 37.0501 28.2275C36.9356 29.2093 36.9514 30.1822 36.9563 31.161C36.9612 32.1556 37.0037 33.1483 36.9534 34.1448C36.9149 34.9017 36.7421 35.6871 37.1646 36.4113C37.2169 36.5011 37.2287 36.6482 37.1962 36.7478C36.8872 37.6852 37.0738 38.6344 37.1054 39.5797C37.135 40.4638 37.1241 41.3499 37.1754 42.232C37.1952 42.5774 36.9938 42.8596 37.0145 43.196C37.0491 43.7476 36.9306 44.2972 37.1044 44.8547C37.288 45.4428 36.8961 45.8533 36.4983 46.2134C36.3138 46.3812 36.1045 46.3279 35.9278 46.1542C35.7739 46.0033 35.7324 45.8138 35.7442 45.6115C35.8321 44.092 35.5153 42.6099 35.3327 41.115C35.228 40.2566 35.2162 39.3912 35.2359 38.5219C35.2488 37.9556 35.3109 37.325 34.773 36.8889C34.4986 36.6659 34.2627 36.6215 33.94 36.8573C33.3823 37.2639 32.873 37.7187 32.3558 38.1717C31.9244 38.5486 32.0301 38.9492 32.1988 39.3232C32.6361 40.2931 33.1316 41.2374 33.5994 42.1945C33.786 42.5764 33.6004 43.4496 33.2727 43.7151C33.0141 43.9242 32.7072 43.9015 32.5157 43.6677C31.9906 43.0273 31.4744 42.3899 30.8052 41.8798C30.6117 41.7317 30.5673 41.3874 30.4557 41.1328C29.8892 39.8432 29.598 38.4558 29.0512 37.1583C28.6209 36.1351 28.2231 35.098 27.7957 34.0728C27.7355 33.9287 27.6003 33.8103 27.4868 33.6939C27.2499 33.4502 27.0189 33.1423 27.0653 32.8335C27.2045 31.9227 26.6517 31.2123 26.4237 30.419C25.9361 28.7238 25.1781 27.1194 24.5316 25.4775C23.9236 23.9303 23.1073 22.4788 22.5151 20.9267C22.4973 20.8803 22.4717 20.8379 22.4549 20.7915C22.1006 19.8206 22.4786 19.3924 23.511 19.4634C25.4989 19.5996 27.4868 19.7732 29.4865 19.5641C30.363 19.4723 31.2572 19.5256 32.1426 19.5404C32.5078 19.5463 32.8631 19.4693 33.2214 19.4703C33.6379 19.4723 34.0456 19.7357 34.47 19.3864C34.6092 19.272 34.8411 19.5177 34.9931 19.6696C35.1066 19.7831 35.1955 19.9449 35.386 19.936C35.5478 19.9291 35.7551 20.1097 35.8637 19.8571C35.9663 19.6164 35.8479 19.4397 35.6357 19.3302C35.3642 19.1911 35.1195 19.0352 35.0602 18.7076C34.9408 18.0465 35.3208 17.6192 36.0196 17.5877C36.1726 17.5807 36.4816 17.7732 36.4717 17.4219C36.4638 17.1565 36.2012 17.1259 35.9772 17.1357C35.7245 17.1466 35.4906 17.0854 35.2547 17.0055C34.9349 16.8969 34.9744 16.7351 35.1728 16.5427C35.2675 16.4509 35.3692 16.3503 35.5074 16.3493C36.5842 16.3444 37.5989 15.9625 38.6688 15.855C40.404 15.6803 42.1244 15.7563 43.8527 15.7908C44.2791 15.7997 44.7074 15.8264 45.1299 15.7257C45.2227 15.704 45.3391 15.6922 45.422 15.7277C46.2778 16.0997 47.1711 15.8609 48.0456 15.8865C48.4118 15.8974 48.7671 15.925 49.1086 16.0503C49.2853 16.1155 49.455 16.1421 49.6367 16.0938C49.9772 16.004 50.297 15.9487 50.3927 16.4302C50.4213 16.5763 50.5901 16.6128 50.6622 16.521C50.9346 16.1717 51.3156 16.2467 51.6788 16.1826C52.2849 16.076 52.8632 16.1382 53.4643 16.224C54.0605 16.3079 54.6508 16.5032 55.2755 16.3878C55.4858 16.3493 55.7246 16.45 55.9467 16.5013C56.0741 16.5309 56.2034 16.6118 56.3277 16.5407C56.8538 16.2388 57.4421 16.4598 57.9918 16.3385C58.2761 16.2753 58.5515 16.376 58.8367 16.5092C59.3451 16.747 59.9027 16.7736 60.4782 16.8052C61.175 16.8427 61.8975 16.7973 62.5786 16.9581C63.6702 17.2157 64.7184 16.8525 65.7884 16.8437C66.5454 16.8377 67.2936 16.6611 68.0566 16.7272C68.3912 16.7558 68.5412 16.9483 68.5027 17.2502C68.4267 17.8472 68.6883 18.1392 69.2647 18.2034C69.624 18.2428 69.8233 18.4589 69.8687 18.8122C69.9438 19.3993 70.0257 19.9785 69.471 20.4255C69.2153 20.6317 69.0041 20.7313 68.6774 20.5764C68.3537 20.4235 68.0013 20.5103 67.6657 20.6031C67.3864 20.68 67.3666 20.906 67.341 21.1458C67.266 21.8552 67.6203 22.4926 67.6716 23.1745C67.7476 24.1819 67.8789 25.1874 67.7891 26.2067C67.7486 26.6734 67.8384 27.151 67.8562 27.6236C67.9065 28.9803 68.0388 30.3302 67.9549 31.6968C67.8809 32.9016 68.0576 34.1133 68.0191 35.3269C67.9806 36.5495 67.8819 37.771 67.9302 38.9956C67.9529 39.5856 67.8838 40.1786 68.023 40.7638C68.1681 41.3736 67.8059 41.9616 67.9065 42.5517C68.0062 43.1398 67.6252 43.7377 67.9845 44.3041C67.9924 44.317 67.9894 44.3367 67.9954 44.3515C68.174 44.7787 68.1484 45.2188 67.9154 45.6619C67.8493 45.7882 67.8651 45.9135 67.8927 46.0457C67.944 46.2884 67.8078 46.4039 67.5996 46.4848C67.3706 46.5736 67.2689 46.4285 67.1574 46.2805C67.0626 46.1552 67.0547 46.0072 67.0291 45.8612C66.9787 45.5671 66.7813 45.4181 66.505 45.4546C66.0786 45.5119 65.6522 45.506 65.2258 45.5168C65.0905 45.5208 64.976 45.5632 64.8704 45.6579C64.2308 46.2243 63.4363 46.2065 62.846 45.6214C62.6052 45.3826 62.2874 45.3422 61.9784 45.3343C60.3183 45.2908 58.668 45.4517 57.0157 45.574C56.3938 45.6204 55.774 45.7319 55.1532 45.729C54.1296 45.724 53.1347 45.9293 52.1328 46.0694C51.668 46.1345 51.1784 46.0891 50.7372 46.3101C50.6059 46.3762 50.4342 46.394 50.3374 46.4907C49.7304 47.0946 49.0346 46.9298 48.3091 46.8025C47.7031 46.6959 47.0951 46.5854 46.4801 46.5075C45.2424 46.3506 44.0047 46.3338 42.765 46.2746C42.383 46.2568 41.999 46.1088 41.6319 45.9776C41.2548 45.8424 41.0347 45.5612 41.1107 45.1369C41.1857 44.7166 41.5282 44.7245 41.8441 44.7324C42.2872 44.7442 42.7304 44.7699 43.1726 44.8024C43.522 44.8281 43.7826 44.7195 43.9277 44.3831C44.0678 44.0565 44.3067 43.9331 44.6719 43.9499C45.1338 43.9716 45.5977 43.944 45.8534 43.4358C45.9363 43.272 46.1268 43.2917 46.2975 43.3036C48.2716 43.4417 50.2338 43.7456 52.2246 43.6292C52.8208 43.5947 53.4387 43.7091 54.0279 43.8394C54.9281 44.0387 55.8283 43.8591 56.7284 43.9134C57.1884 43.941 57.3907 43.571 57.2358 43.1309C56.6988 41.5995 56.1797 40.0612 55.5035 38.5821C55.4562 38.4785 55.4305 38.3641 55.4029 38.2526C55.0949 36.9708 54.5086 35.7867 54.098 34.5425C53.7812 33.5834 53.5275 32.6026 53.187 31.6524C52.6905 30.2641 52.1644 28.8866 51.7351 27.4746C51.6245 27.1095 51.3955 27.146 51.205 27.4105C50.8675 27.8772 50.6276 28.4021 50.3986 28.928C50.0788 29.6622 49.76 30.3983 49.4768 31.1472C48.9428 32.5572 48.4364 33.9781 47.9133 35.3921C47.7998 35.6979 47.6448 35.99 47.5343 36.2969C47.1306 37.4148 46.796 38.5614 46.3193 39.6458C46.0468 40.2675 45.9087 40.9078 45.7162 41.5423C45.5277 42.1629 44.6324 42.6385 44.0086 42.4698C43.8764 42.4343 43.7757 42.3494 43.6957 42.2409C43.5891 42.0949 43.5052 41.9281 43.3799 41.8008C43.2062 41.6252 43.1262 41.2769 42.8045 41.344C42.5004 41.4071 42.4837 41.7268 42.4027 41.9725C42.2448 42.4511 41.9063 42.8329 41.7266 43.3125C41.5608 43.7545 40.8393 43.6864 40.4889 43.2473C40.2184 42.9079 40.0941 42.5083 40.1869 42.0909C40.3132 41.5176 40.482 40.9512 40.6656 40.3937C40.785 40.0316 40.9488 39.6656 40.8886 39.2936C40.7327 38.3305 41.2094 37.5027 41.4305 36.6294C41.7266 35.4572 42.2438 34.3649 42.8676 33.3111C43.3888 32.4299 43.7056 31.4343 44.1814 30.5186C44.3797 30.1358 44.6847 29.8398 44.819 29.3849C45.0529 28.5975 45.4546 27.8535 45.8376 27.1184C46.4338 25.9748 46.8365 24.7552 47.2964 23.5593C47.3477 23.4261 47.3576 23.2692 47.3546 23.1241C47.3468 22.762 47.3922 22.4522 47.9015 22.4315L47.9034 22.4334ZM65.818 22.9939C65.818 22.8054 65.818 22.7068 65.818 22.6081C65.818 21.796 65.7903 21.7477 65.0057 21.6066C63.8341 21.3954 62.6516 21.4517 61.4691 21.4842C60.7861 21.503 60.1011 21.502 59.4181 21.4773C58.2712 21.4349 57.1233 21.4655 55.9744 21.3806C55.4808 21.3441 54.9706 21.6263 54.5027 21.2208C54.3833 21.1172 54.2135 21.2079 54.1138 21.3332C53.9964 21.4793 54.0516 21.6105 54.1799 21.7191C54.4168 21.9203 54.5313 22.1966 54.6063 22.4798C54.6823 22.7689 54.8363 22.99 55.0801 23.1409C55.3999 23.3393 55.5628 23.6244 55.6052 23.9865C55.7138 24.921 56.2053 25.7143 56.608 26.5254C56.9555 27.226 57.2871 27.963 57.4934 28.6784C57.8122 29.7825 58.3679 30.8018 58.5781 31.9346C58.6008 32.0589 58.7163 32.1112 58.7903 32.1971C59.3283 32.8216 59.8563 33.4828 59.9787 34.3086C60.1515 35.4769 60.8404 36.4676 61.0191 37.623C61.024 37.6536 61.0467 37.6822 61.0615 37.7118C62.0229 39.5422 62.7552 41.4772 63.6218 43.35C63.9051 43.9617 64.2822 44.4215 64.9099 44.611C65.3788 44.7521 65.8831 44.6445 66.3589 44.5676C66.654 44.5202 66.8623 44.3416 66.9432 43.9509C67.0528 43.421 66.8623 42.9898 66.7497 42.5182C66.581 41.8097 66.1131 41.193 66.2049 40.3997C66.3609 39.0459 66.1516 37.6872 66.1654 36.3265C66.1822 34.7043 66.1101 33.0713 66.1447 31.4481C66.1743 30.0598 66.118 28.6774 66.0914 27.293C66.0736 26.3961 65.8515 25.5061 66.0233 24.6023C66.0499 24.4651 66.0144 24.3043 65.967 24.1671C65.8269 23.7547 65.7923 23.3343 65.819 22.9939H65.818ZM34.1719 32.272C34.1699 32.2276 34.1759 32.0944 34.1541 31.9662C34.1018 31.6672 33.936 31.5162 33.6981 31.7856C33.2007 32.349 32.5779 32.792 32.1396 33.4107C31.9955 33.614 31.8149 33.8636 32.0103 34.0758C32.3686 34.4655 31.9876 34.5859 31.7981 34.7487C31.6155 34.9066 31.3747 34.9944 31.1723 35.1306C30.9058 35.3111 30.7913 35.5657 30.8358 35.8943C30.895 36.3294 31.1644 36.4656 31.5079 36.2012C31.7794 35.992 32.033 35.7571 32.2778 35.5164C32.5996 35.1996 32.6953 34.7724 32.6854 34.354C32.6756 33.9051 32.8246 33.6189 33.2668 33.5114C34.0357 33.3239 34.1689 33.1552 34.1739 32.272H34.1719ZM53.189 24.2066C53.1742 24.0872 53.1742 23.953 53.1386 23.8297C53.0991 23.6935 53.0725 23.506 52.8869 23.509C52.7152 23.5119 52.6688 23.6797 52.6155 23.8198C52.428 24.3062 52.5425 25.0335 52.9333 25.2565C53.2699 25.4489 53.3883 25.7242 53.5216 26.0448C53.8118 26.7444 54.1691 27.4174 54.177 28.2058C54.179 28.3557 54.2757 28.5709 54.4682 28.5422C54.6547 28.5146 54.5836 28.3034 54.5935 28.1653C54.6636 27.225 54.0487 26.4741 53.8759 25.5979C53.8226 25.3265 53.64 25.1055 53.4298 24.9062C53.2442 24.7305 53.0399 24.5273 53.189 24.2056V24.2066ZM59.4142 41.8906C59.2345 41.8906 59.1792 41.9764 59.2394 42.1432C59.3569 42.4669 59.4151 42.83 59.6046 43.1033C59.8494 43.4555 60.034 43.8877 60.4831 44.0673C60.6321 44.1265 60.7782 44.1334 60.9075 44.0515C61.0635 43.9519 60.946 43.8108 60.9194 43.6953C60.8236 43.2848 60.6509 42.9296 60.2285 42.7461C59.9886 42.6425 59.7754 42.5093 59.7566 42.1866C59.7478 42.0218 59.6086 41.8975 59.4142 41.8906ZM27.6141 21.0668C27.1354 20.9583 27.0288 21.4418 26.7643 21.6924C26.6873 21.7654 26.7455 21.8779 26.7998 21.9628C26.8827 22.092 26.9913 22.0486 27.1008 22.0052C27.3565 21.9026 27.6161 21.8098 27.8678 21.6993C28.0543 21.6174 28.3494 21.5503 28.3159 21.3273C28.2774 21.0728 27.9823 21.0698 27.7503 21.0678C27.7177 21.0678 27.6852 21.0678 27.6141 21.0678V21.0668Z"
                    fill="white" />
                  <path
                    d="M49.7168 3.55216C50.4591 3.96362 51.2625 3.91034 52.0511 3.9952C53.6857 4.17084 55.3281 4.16492 56.9646 4.26852C58.0967 4.33957 59.2249 4.13235 60.3609 4.18169C61.721 4.24089 63.0812 4.24681 64.4324 4.00112C64.7808 3.93797 65.1154 3.83338 65.4007 3.66267C65.8113 3.41698 65.6267 2.9621 65.6376 2.58517C65.6435 2.38092 65.5241 2.17568 65.7185 1.98327C65.9189 1.78494 66.1281 1.64779 66.4173 1.72179C66.7105 1.79678 66.902 1.98426 66.9928 2.27534C67.0697 2.52202 67.0994 2.77364 67.2366 3.01538C67.5238 3.52157 67.9216 3.76332 68.497 3.80674C68.8691 3.83436 69.2392 3.94488 69.5689 4.13926C69.7831 4.26556 69.9203 4.45205 69.8482 4.71353C69.7653 5.01251 69.5057 5.00067 69.2817 4.96219C68.9708 4.9089 68.6618 4.88818 68.3489 4.90397C67.737 4.93357 67.5652 5.10723 67.5544 5.71703C67.5455 6.17684 67.5613 6.63764 67.5494 7.09844C67.5307 7.88486 67.5939 8.67127 67.4685 9.45868C67.3915 9.94217 67.5346 10.4415 67.5317 10.9259C67.5238 11.9393 67.4231 12.9517 67.3402 13.9631C67.3165 14.2532 67.1319 14.4406 66.8171 14.4495C66.6365 14.4544 66.4548 14.4544 66.2742 14.4515C65.9001 14.4446 65.6652 14.3074 65.6109 13.8871C65.4727 12.8165 65.3987 11.7469 65.4293 10.6645C65.4757 9.02748 65.5251 7.38854 65.4421 5.75156C65.4224 5.36378 65.2773 5.17039 64.8134 5.23354C64.2982 5.30359 63.7662 5.26116 63.2421 5.25031C62.1958 5.22761 61.1634 5.49008 60.1013 5.2957C59.5062 5.18716 58.8685 5.26116 58.2546 5.26215C55.8226 5.26215 53.4073 4.97896 50.9832 4.89706C49.0071 4.82997 47.0469 4.53691 45.061 4.56947C44.4382 4.57934 43.767 4.41653 43.1462 4.456C42.4108 4.50336 41.717 4.33266 41.0033 4.3149C39.6955 4.28332 38.4025 4.00408 37.0878 4.09486C36.8262 4.11262 36.5627 4.08598 36.3002 4.09486C35.6181 4.11657 35.1414 4.38594 35.2016 5.35885C35.2421 6.00614 35.4178 6.63665 35.3832 7.28986C35.3684 7.57009 35.5253 7.65495 35.8066 7.55825C36.5301 7.3096 36.615 7.42504 36.6081 8.16114C36.6032 8.5874 36.7522 9.02057 36.7325 9.4646C36.7216 9.71227 36.7206 9.9471 36.5528 10.1622C36.4087 10.3467 36.3929 10.552 36.5568 10.7671C36.6733 10.918 36.772 11.1026 36.6209 11.3088C36.5203 11.4459 36.5973 11.5782 36.6446 11.7242C36.7463 12.037 36.7621 12.3596 36.613 12.6705C36.5854 12.7277 36.5213 12.8264 36.5331 12.8372C36.9378 13.1836 36.6545 13.3552 36.4068 13.6315C36.1649 13.9019 36.2044 14.3064 36.314 14.6696C36.4077 14.9794 36.3683 15.2971 36.2094 15.5606C35.9616 15.971 34.4998 15.9089 34.2462 15.4974C34.1553 15.3494 34.1741 15.1797 34.1721 15.0169C34.1652 14.5235 34.1721 14.0302 34.1494 13.5378C34.1405 13.3464 34.103 13.0869 33.8049 13.3029C33.269 13.6907 32.8564 13.4194 32.4547 13.0701C31.9651 12.6438 31.3798 12.6537 31.0196 13.0859C30.9031 13.225 30.8676 13.3306 30.9534 13.52C31.2091 14.0834 31.5318 14.5077 32.2375 14.4554C32.4448 14.4396 32.658 14.5166 32.8702 14.5403C33.1733 14.5748 33.4249 14.6676 33.4467 15.0248C33.4664 15.3691 33.419 15.6622 33.0282 15.822C32.6343 15.9839 32.2415 16.0342 31.825 16.0016C30.1727 15.8743 28.5204 15.8467 26.8622 15.8556C25.2593 15.8635 23.6534 15.8615 22.0475 15.7757C21.3042 15.7362 20.5275 15.5379 19.7714 15.8043C19.3174 15.9641 18.9107 15.6711 18.4794 15.6069C17.6927 15.4895 16.9159 15.5714 16.1342 15.6158C14.0792 15.7332 12.0242 15.6997 9.97021 15.5704C9.69285 15.5527 9.41352 15.5596 9.13419 15.5527C7.62404 15.5122 6.11487 15.4816 4.60571 15.4254C4.11812 15.4076 3.78845 15.599 3.55946 16.0115C3.35317 16.3835 3.11925 16.8542 2.66817 16.7969C2.225 16.7407 2.07793 16.2236 1.97725 15.822C1.83808 15.2645 1.36036 15.3001 0.977396 15.1688C0.7869 15.1037 0.520402 15.1738 0.50461 14.857C0.490791 14.5689 0.651677 14.3706 0.907317 14.3055C1.56073 14.1377 1.70582 13.7036 1.70681 13.0849C1.71076 11.2338 1.7532 9.38369 1.7986 7.5326C1.82723 6.38011 1.71273 5.23748 1.60613 4.09387C1.58442 3.86002 1.66535 3.72188 1.84598 3.60544C1.96541 3.52848 2.14209 3.46533 2.06313 3.27588C1.99996 3.12294 1.8371 3.08939 1.68509 3.09432C1.3347 3.10616 1.00701 3.00453 0.669443 2.93447C0.302269 2.8585 0.139409 2.62464 0.0387327 2.31975C-0.0876069 1.93591 0.0792007 1.69318 0.482895 1.71094C1.10275 1.73857 1.72754 1.64187 2.34443 1.81158C2.82412 1.94381 3.31764 1.96157 3.80918 1.84612C4.03225 1.79382 4.19708 1.88263 4.32046 2.05728C4.46654 2.26449 4.70441 2.4125 4.90971 2.3454C5.68453 2.09181 6.49587 2.4569 7.24897 2.19443C7.96259 1.94578 8.63377 2.25265 9.32074 2.24574C11.2247 2.22798 13.1672 2.61083 15.009 1.76916C15.3456 1.61523 15.7177 1.64088 16.0227 1.92506C16.1845 2.07603 16.3967 2.15891 16.604 2.17371C17.4094 2.23094 18.2109 2.47663 19.0252 2.24377C19.1584 2.20529 19.2828 2.25265 19.4111 2.28126C19.8198 2.37007 20.2017 2.56939 20.6508 2.301C20.9706 2.10957 21.3714 2.3454 21.7474 2.34047C23.0049 2.32567 24.2653 2.49637 25.5218 2.46775C26.7289 2.44111 27.9331 2.53386 29.1462 2.45394C30.2447 2.38191 31.3601 2.2783 32.4725 2.41447C33.0627 2.48749 33.3588 2.17568 33.3519 1.58267C33.3489 1.30342 33.3726 1.03109 33.4121 0.752832C33.4832 0.255525 33.8464 0.12133 34.2284 0.0256184C34.5689 -0.0602264 34.8009 0.0937022 34.8551 0.465696C34.9272 0.951163 35.0052 1.43663 35.0812 1.92111C35.1828 2.56939 35.2756 2.68187 35.8422 2.58419C36.1126 2.53781 36.3939 2.56741 36.6703 2.64931C37.0345 2.75686 37.4106 2.81311 37.7639 2.58912C37.7906 2.57235 37.8261 2.56643 37.8587 2.56445C39.1112 2.47071 40.3716 2.43322 41.6153 2.26844C42.5253 2.14806 43.3742 2.5536 44.2852 2.41644C44.8567 2.3306 45.4627 2.44013 46.049 2.50328C47.1811 2.62563 48.3133 2.52794 49.4444 2.55064C50.6624 2.57432 51.8646 2.3681 53.0688 2.34343C55.0241 2.30297 56.9873 2.30593 58.9426 2.46282C59.1646 2.48058 59.4045 2.43421 59.6197 2.36514C60.1675 2.19049 60.6965 2.37599 61.2305 2.41941C61.493 2.44111 61.6243 2.6503 61.5898 2.91869C61.5513 3.21372 61.3292 3.40711 61.0765 3.32028C60.4685 3.11011 59.8358 3.25121 59.2278 3.118C59.1005 3.09038 58.9623 3.07064 58.836 3.09038C57.995 3.21865 57.1403 3.08051 56.2993 3.2443C55.8591 3.33015 55.411 3.2226 54.9787 3.15254C54.4644 3.06965 53.966 3.08742 53.4616 3.16142C52.7134 3.27193 51.9643 3.35383 51.2072 3.28575C50.6851 3.23838 50.2271 3.53144 49.7129 3.55315L49.7168 3.55216ZM18.2918 13.7637C18.4389 13.7559 18.5919 13.7697 18.733 13.7361C19.1357 13.6404 19.4684 13.3562 19.8543 13.2457C20.6972 13.005 21.0456 12.4257 21.1256 11.6166C21.1364 11.5032 21.2055 11.4538 21.2924 11.3956C21.777 11.072 21.8392 10.8884 21.5717 10.3931C21.402 10.0783 21.3112 9.76061 21.3388 9.40638C21.3635 9.08471 21.1996 8.88835 20.9766 8.65647C20.6686 8.33678 20.1909 8.32099 19.9441 8.07727C19.2937 7.43491 18.5356 7.50596 17.7815 7.56911C17.3551 7.60463 16.8774 7.73191 16.5636 8.03484C16.3977 8.19469 16.3049 8.26178 16.1372 8.16015C15.7512 7.9263 15.539 8.22034 15.4492 8.46505C15.3683 8.68509 15.2084 8.85184 15.1432 9.0561C14.9369 9.69746 14.5619 10.324 14.853 11.0384C14.9981 11.3956 15.0475 11.7617 15.0119 12.1455C14.9843 12.4415 15.082 12.6714 15.3416 12.8619C16.223 13.5111 17.3216 13.4214 18.2928 13.7637H18.2918ZM24.2525 4.17478C23.9436 4.08992 23.7077 3.85311 23.3819 3.84916C21.8175 3.82844 20.254 3.80674 18.6896 3.7722C18.2 3.76135 17.7105 3.70017 17.2209 3.68636C16.9613 3.67846 16.7343 3.78897 16.8468 4.10177C16.9593 4.41554 17.1706 4.73228 17.521 4.75202C18.3066 4.79444 19.0745 4.9987 19.8671 4.96909C21.3615 4.91186 22.7907 4.50533 24.2525 4.17577V4.17478ZM3.55255 10.5964C3.57032 10.8085 3.55453 11.0305 3.61375 11.2298C3.67593 11.4351 3.7312 11.738 4.02238 11.7054C4.3708 11.666 4.66493 11.4657 4.8574 11.1598C4.92156 11.0582 4.82878 10.9822 4.74192 10.924C4.38659 10.6852 4.2563 10.3724 4.39745 9.95006C4.44384 9.81094 4.44186 9.64418 4.27604 9.56228C4.11318 9.48137 3.96315 9.52281 3.82201 9.63826C3.50517 9.89777 3.5713 10.254 3.55255 10.5954V10.5964ZM31.9513 9.98164C32.4853 9.77443 33.1042 9.48631 33.6776 9.11431C33.9056 8.9663 33.9086 8.68213 33.8365 8.43742C33.7734 8.22232 33.6372 8.05951 33.423 8.30717C33.1545 8.617 32.7972 8.77192 32.4409 8.94164C32.129 9.08964 31.8398 9.28205 31.6137 9.54847C31.5328 9.64418 31.4262 9.76357 31.5071 9.89876C31.5753 10.0103 31.7154 9.95895 31.9513 9.98263V9.98164ZM12.647 4.96219C12.7388 4.93653 12.8879 4.93259 12.9856 4.85957C13.3725 4.5675 13.8384 4.55368 14.2815 4.456C14.4247 4.42442 14.5678 4.38002 14.701 4.31983C14.859 4.24879 15.0978 4.20833 15.0662 3.98336C15.0297 3.72582 14.779 3.76135 14.5895 3.75543C13.7219 3.72681 13.0744 4.20636 12.4358 4.70169C12.3924 4.73524 12.346 4.81714 12.3578 4.85957C12.3934 4.98389 12.5148 4.94443 12.646 4.96219H12.647Z"
                    fill="white" />
                  <path
                    d="M13.1295 45.1811C12.9291 45.0933 12.7317 44.9956 12.5274 44.9177C12.0329 44.7302 11.8305 44.3907 12.0605 43.9181C12.3537 43.3142 11.9855 42.7617 12.0181 42.1825C12.0299 41.9802 11.8187 41.997 11.6776 42.069C11.5019 42.1578 11.339 42.2515 11.1307 42.2703C10.197 42.3561 9.65415 41.625 10.0223 40.7478C10.4921 39.6288 11.0972 38.577 11.642 37.4955C11.9223 36.939 12.2323 36.3944 12.3635 35.7757C12.4228 35.4974 12.5659 35.2567 12.7149 35.0198C13.5628 33.672 14.23 32.2284 14.9565 30.8154C15.6158 29.5337 16.3146 28.2726 17.0006 27.0057C17.2266 26.5883 17.3411 26.1206 17.6224 25.7249C18.0508 25.123 18.8967 25.0954 19.329 25.6924C19.7218 26.2351 19.7998 26.9139 20.1186 27.4892C20.7592 28.6437 20.9734 29.954 21.4541 31.1657C22.0621 32.6981 22.5457 34.2838 23.3679 35.7263C23.4311 35.8378 23.4824 35.9701 23.4893 36.0964C23.5318 36.9292 23.9789 37.5981 24.3461 38.3056C24.8514 39.2815 25.2048 40.3176 25.4821 41.3803C25.6588 42.0581 25.8394 42.733 26.2392 43.328C26.4583 43.6546 26.3231 44.3562 26.027 44.5989C25.9184 44.6877 25.7891 44.7558 25.6647 44.6868C25.2768 44.4726 24.8514 44.2575 24.731 43.7977C24.6422 43.4612 24.4961 43.2373 24.1792 43.106C23.8841 42.9837 23.7301 42.8021 23.7677 42.4291C23.818 41.9308 23.5535 41.7818 23.0886 41.9782C22.8211 42.0917 22.5783 42.2545 22.3167 42.3818C22.0275 42.5229 21.8489 42.8426 21.9496 43.1741C22.1213 43.7395 21.763 43.8668 21.3613 43.9655C21.0366 44.0454 20.7335 44.1628 20.4818 44.3828C20.0791 44.7351 20.1028 44.9127 20.5973 45.1012C21.1876 45.3262 21.8104 45.3923 22.4362 45.3893C23.3403 45.3844 24.2395 45.4268 25.1248 45.6202C25.568 45.7169 25.9164 45.93 26.0033 46.4313C26.0368 46.6227 25.9825 46.7332 25.7911 46.7233C25.3637 46.7007 24.9393 46.7914 24.5296 46.8536C23.1981 47.0569 21.8489 46.8911 20.5233 47.1141C20.395 47.1358 20.2607 47.124 20.1295 47.1269C19.3941 47.1467 18.6647 47.1023 17.9264 47.273C17.2049 47.4397 16.4597 47.1871 15.7204 47.1841C14.2507 47.1772 12.8235 46.6622 11.337 46.823C10.9629 46.8635 10.581 46.8309 10.2148 46.9444C10.0115 47.0075 9.82589 47.0164 9.68277 46.825C9.56927 46.673 9.5742 46.5132 9.6808 46.3681C9.80813 46.1955 9.95026 46.004 10.201 46.0692C10.8346 46.2349 11.3449 46.0455 11.7703 45.5689C11.946 45.3725 12.174 45.2985 12.4356 45.3084C12.6567 45.3163 12.8788 45.3104 13.1008 45.3104C13.1097 45.267 13.1186 45.2235 13.1275 45.1791L13.1295 45.1811ZM18.2097 39.8716C18.719 40.3491 18.2975 40.3856 18.0251 40.5267C17.8721 40.6057 17.7517 40.7557 17.6333 40.8889C17.426 41.1207 17.1842 41.2895 16.8664 41.2184C16.587 41.1563 16.44 41.2697 16.3077 41.4898C16.1251 41.7927 15.8418 41.9427 15.5191 42.1015C14.8943 42.4084 14.3159 42.8199 13.8036 43.3034C13.5973 43.4978 13.6082 43.6517 13.923 43.7543C14.5834 43.9684 15.2733 43.996 15.9484 44.1085C16.2514 44.1589 16.4104 43.9872 16.3452 43.6596C16.284 43.3497 16.2001 42.9827 16.4814 42.7844C17.0549 42.3788 17.4497 41.7818 18.0804 41.4306C18.797 41.031 18.8473 40.4488 18.2107 39.8716H18.2097ZM18.7279 39.1177C18.6805 39.4394 18.9352 39.7502 18.9993 40.1172C19.0358 40.3245 19.2856 40.3116 19.4277 40.137C19.7761 39.7087 20.2696 39.4561 20.6743 39.097C20.9655 38.8385 21.2863 38.6125 21.5883 38.3638C21.8903 38.1142 21.9061 37.7748 21.7383 37.4758C21.5459 37.1314 21.2655 37.3229 21.0198 37.464C20.3575 37.8468 19.6922 38.2247 19.0319 38.6115C18.8661 38.7082 18.6716 38.8 18.7269 39.1177H18.7279Z"
                    fill="white" />
                  <path
                    d="M1.77173 39.1356C2.07277 37.5627 1.94742 35.9652 2.04415 34.3796C2.10929 33.309 2.27018 32.2344 2.15963 31.152C2.13693 30.932 2.17641 30.6764 2.27314 30.4791C2.41823 30.1821 2.36 29.9028 2.37579 29.6068C2.39356 29.2762 2.36987 28.9348 2.41823 28.6073C2.45475 28.3596 2.436 28.1277 2.43106 27.885C2.42613 27.6343 2.26722 27.3561 2.53075 27.1124C2.60873 27.0403 2.62057 26.7966 2.56036 26.6901C2.20503 26.0645 2.56629 25.4142 2.46462 24.7837C2.45278 24.7087 2.45771 24.5883 2.5041 24.5528C3.00156 24.1759 2.65709 23.7763 2.62649 23.3372C2.56727 22.4629 2.47745 21.5936 2.39356 20.7224C2.37875 20.5753 2.44093 20.4214 2.60478 20.3642C2.82785 20.2862 2.95616 20.0958 3.04203 19.9152C3.26806 19.4376 3.65596 19.4031 4.07644 19.5018C4.69136 19.6468 5.33885 19.706 5.86789 20.1116C6.02286 20.23 6.16795 20.1214 6.26566 20.0307C6.70884 19.6202 7.11352 19.7643 7.4807 20.1155C7.67218 20.2981 7.78766 20.3217 8.01566 20.157C8.28216 19.9655 8.63552 19.9142 8.95531 19.9655C9.74198 20.0918 10.5198 20.0366 11.3074 19.9942C11.8483 19.9655 12.4208 19.9517 12.933 20.228C13.1798 20.3612 13.4226 20.3938 13.6832 20.2487C13.9497 20.0997 14.2073 19.9892 14.4797 20.2852C14.7531 20.5832 14.7551 20.895 14.6366 21.2404C14.6258 21.271 14.606 21.2986 14.5863 21.3252C13.851 22.2656 13.4877 23.3944 12.9775 24.4502C12.6152 25.1981 12.097 25.8691 11.717 26.617C11.5157 27.0117 11.4337 27.4429 11.2205 27.8396C10.4072 29.3552 9.68572 30.9182 8.84181 32.4199C8.29697 33.3899 7.86366 34.419 7.3662 35.4097C6.9704 36.1981 6.71378 37.0467 6.25185 37.8005C6.15413 37.9594 6.0199 38.0729 5.85704 38.1627C5.28555 38.4755 4.87692 38.2702 4.82757 37.6269C4.80486 37.3328 4.80684 37.0348 4.82164 36.7398C4.83941 36.3708 4.64497 36.1004 4.33603 36.0284C4.03893 35.9593 3.84646 36.2435 3.71716 36.4961C3.47929 36.9599 3.50001 37.4641 3.60464 37.9446C3.75565 38.6402 3.50988 39.3487 3.73295 40.0453C3.8129 40.2969 3.17429 41.0044 2.88213 41.0538C2.49917 41.1199 2.37085 40.7893 2.1547 40.5703C1.7431 40.1519 1.78752 39.6477 1.77272 39.1366L1.77173 39.1356Z"
                    fill="white" />
                  <path
                    d="M17.5337 69.798C16.7283 69.798 15.9218 69.7961 15.1164 69.799C14.8351 69.8 14.6328 69.7319 14.6367 69.3915C14.6407 69.0718 14.842 69.0294 15.0957 69.0136C15.8103 68.9682 15.8113 68.9633 15.8113 68.2459C15.8113 65.7801 15.8113 63.3143 15.8113 60.8475C15.8113 60.1706 15.8093 60.1647 15.1431 60.1449C14.8736 60.1371 14.6486 60.1114 14.6367 59.7631C14.6249 59.4237 14.8213 59.3418 15.1056 59.3467C16.7815 59.3743 18.4605 59.2658 20.1345 59.4089C22.4639 59.6072 24.357 61.3162 24.7844 63.5797C25.2206 65.8916 24.0362 68.2834 21.9506 69.3057C21.2577 69.6461 20.5165 69.7813 19.7545 69.7971C19.0152 69.8128 18.2749 69.8 17.5347 69.799L17.5337 69.798ZM17.9808 64.5142C17.9808 65.7781 17.9798 67.0411 17.9818 68.3051C17.9818 68.5163 17.9571 68.7719 18.2631 68.7886C19.2037 68.8399 20.1374 68.8607 20.9438 68.2311C22.0217 67.3904 22.4254 66.236 22.5626 64.9315C22.8389 62.3207 21.0425 60.3048 18.4792 60.3482C18.0834 60.3551 17.9699 60.4972 17.9739 60.8702C17.9887 62.0848 17.9798 63.2995 17.9798 64.5132L17.9808 64.5142Z"
                    fill="white" />
                  <path
                    d="M4.04298 69.7988C2.95824 69.7988 1.87349 69.7988 0.788751 69.7988C0.508435 69.7988 0.263652 69.7811 0.271548 69.3874C0.278457 69.0124 0.527188 69.0272 0.776906 69.0144C1.23028 68.9914 1.4573 68.7463 1.45796 68.2793C1.45796 65.8145 1.45993 63.3496 1.45697 60.8848C1.45697 60.2424 1.58824 60.1033 0.748283 60.1428C0.384069 60.1596 0.233054 60.0037 0.280431 59.6415C0.33077 59.2646 0.629839 59.3495 0.853894 59.3485C2.43215 59.3396 4.00942 59.3435 5.58768 59.3426C5.81766 59.3426 6.04763 59.3426 6.27761 59.3396C6.44343 59.3366 6.60432 59.3297 6.69118 59.1413C6.8412 58.8137 7.13929 58.9193 7.3821 58.9498C7.68314 58.9883 7.62392 59.2587 7.62688 59.461C7.63477 59.9869 7.62194 60.5128 7.63181 61.0387C7.63774 61.3584 7.5341 61.5272 7.18074 61.5262C6.8491 61.5252 6.6665 61.4038 6.71289 61.0644C6.78791 60.5148 6.51943 60.3924 6.02888 60.4171C5.37349 60.4497 4.71416 60.4378 4.0568 60.421C3.69259 60.4122 3.56131 60.5621 3.56723 60.9184C3.58105 61.7729 3.58204 62.6274 3.56723 63.4819C3.56131 63.846 3.70838 63.9841 4.0647 63.9703C4.50787 63.9535 4.95302 63.9496 5.39521 63.9713C5.79693 63.992 5.98249 63.8381 5.94301 63.4305C5.90353 63.025 6.10192 62.8652 6.49673 62.8839C6.75533 62.8957 6.90437 62.9974 6.90437 63.2638C6.90635 64.0857 6.90635 64.9067 6.90437 65.7286C6.90339 66.0937 6.64281 66.072 6.38618 66.0819C6.10389 66.0927 5.97163 65.9891 5.94301 65.6951C5.8749 64.9935 5.86405 64.9945 5.17905 64.9945C4.78424 64.9945 4.38943 65.0044 3.9956 64.9925C3.71035 64.9836 3.56822 65.0863 3.57019 65.3882C3.5771 66.3907 3.57513 67.3932 3.57118 68.3947C3.57019 68.6641 3.68864 68.7776 3.96007 68.7756C4.78226 68.7687 5.60347 68.7638 6.42567 68.7766C6.86391 68.7835 6.83232 68.4905 6.82936 68.2083C6.82541 67.8659 6.85996 67.5886 7.32386 67.6024C7.66241 67.6123 7.80356 67.7475 7.8006 68.0741C7.79665 68.4845 7.7927 68.896 7.80356 69.3065C7.81244 69.6607 7.65451 69.8058 7.29918 69.8028C6.21444 69.7919 5.1297 69.7988 4.04496 69.7998L4.04298 69.7988Z"
                    fill="white" />
                  <path
                    d="M65.2712 64.7025C65.2712 65.9517 65.285 67.2009 65.2633 68.4491C65.2554 68.8813 65.4074 69.0273 65.8348 69.0244C66.1309 69.0224 66.6146 68.832 66.6077 69.4112C66.6007 69.9845 66.122 69.7851 65.823 69.7911C64.7224 69.8128 63.6199 69.8019 62.5194 69.797C62.2637 69.796 61.9755 69.8404 61.9617 69.4289C61.9469 68.9898 62.246 68.9928 62.5233 69.0204C63.0336 69.0717 63.1619 68.8586 63.158 68.3692C63.1363 65.8383 63.1353 63.3073 63.158 60.7774C63.1629 60.285 63.0346 60.0738 62.5253 60.135C62.3437 60.1567 62.1177 60.1972 61.9982 59.9732C61.8413 59.6782 62.0091 59.3525 62.3546 59.3545C63.997 59.3624 65.6433 59.2568 67.2818 59.4117C68.6044 59.537 69.5559 60.3225 69.8806 61.4908C70.235 62.7676 69.7938 64.0779 68.7288 64.8634C67.9836 65.413 67.1426 65.635 66.2198 65.5541C65.8891 65.5255 65.7174 65.3903 65.7282 65.0262C65.7381 64.671 65.9394 64.6522 66.2138 64.6404C67.0232 64.6058 67.4901 64.219 67.6894 63.4405C67.8513 62.807 67.8513 62.1696 67.6756 61.5391C67.416 60.6086 66.4004 60.0719 65.4854 60.3669C65.2169 60.4537 65.2762 60.6718 65.2752 60.8563C65.2702 62.138 65.2722 63.4198 65.2722 64.7015L65.2712 64.7025Z"
                    fill="white" />
                  <path
                    d="M51.4499 14.9489C50.4846 15.017 49.841 14.5384 49.231 13.83C48.7809 13.307 48.4266 12.79 48.2736 12.121C48.1947 11.7746 48.1344 11.449 48.3358 11.1234C48.4029 11.0149 48.4621 10.8826 48.4681 10.7593C48.5243 9.56339 49.2784 8.91512 50.2723 8.47405C51.1084 8.10304 51.9779 7.85538 52.8998 8.12475C53.8069 8.38919 54.5699 8.80559 54.8324 9.83671C54.9617 10.3449 55.3545 10.7563 55.3022 11.3553C55.243 12.0292 54.9291 12.5867 54.6271 13.1442C54.1227 14.0737 53.1801 14.4664 52.278 14.8858C52.0154 15.0081 51.7253 14.9223 51.4499 14.9499V14.9489Z"
                    fill="white" />
                  <path
                    d="M40.482 60.4981C40.482 60.8434 40.4741 61.1888 40.484 61.5331C40.4938 61.8795 40.3142 61.992 39.9954 61.991C39.6904 61.99 39.4456 61.9081 39.4969 61.5529C39.5877 60.9283 39.1969 60.6747 38.728 60.4497C37.1211 59.6791 35.1145 60.3461 34.2815 62.0492C33.3783 63.8944 33.4484 65.7514 34.6447 67.4712C35.5774 68.8132 37.2564 69.2848 38.7636 68.7352C39.2729 68.5497 39.5532 68.2932 39.4989 67.7002C39.4515 67.1821 39.5986 67.0923 40.0921 67.1239C40.3586 67.1417 40.482 67.2581 40.48 67.5206C40.478 67.7179 40.483 67.9153 40.483 68.1126C40.483 68.973 40.0582 69.5105 39.2087 69.7249C37.8091 70.0791 36.4154 70.1196 35.0287 69.6588C32.6776 68.8783 31.2286 66.7342 31.3994 64.2802C31.575 61.7453 33.2865 59.7669 35.7077 59.2963C36.8102 59.0821 37.8979 59.1177 38.9649 59.4857C39.2423 59.5814 39.4367 59.6386 39.5315 59.2341C39.6045 58.9223 39.9411 59.0486 40.173 59.0466C40.405 59.0446 40.477 59.2084 40.479 59.4117C40.482 59.7728 40.479 60.135 40.479 60.4961H40.481L40.482 60.4981Z"
                    fill="white" />
                  <path
                    d="M52.2592 64.7121C52.2592 65.9455 52.28 67.1789 52.2494 68.4113C52.2365 68.9017 52.4162 69.0645 52.8781 69.0161C53.0725 68.9954 53.2719 69.0161 53.4693 69.026C53.72 69.0379 53.802 69.1918 53.8029 69.4227C53.8039 69.6664 53.6934 69.7927 53.4486 69.7937C51.9681 69.7937 50.4885 69.7937 49.008 69.7937C48.7405 69.7937 48.6349 69.6585 48.6368 69.3901C48.6388 69.1365 48.7553 69.0319 48.9912 69.0221C49.0238 69.0211 49.0573 69.0181 49.0899 69.0161C49.7953 68.9662 50.148 68.5784 50.148 67.8528C50.148 65.5833 50.1381 63.3149 50.1559 61.0454C50.1598 60.5797 50.0226 60.3823 49.54 60.4198C49.1313 60.4514 48.7178 60.4258 48.3072 60.4267C47.6024 60.4287 47.5906 60.4287 47.5827 61.1273C47.5787 61.4914 47.5047 61.7282 47.0645 61.7144C46.7299 61.7036 46.5868 61.5802 46.5927 61.2437C46.6036 60.6359 46.5927 60.0271 46.5976 59.4183C46.5986 59.2417 46.569 59.0128 46.7931 58.9624C47.0398 58.9072 47.3468 58.8184 47.5195 59.0818C47.6883 59.3404 47.9114 59.3433 48.1611 59.3433C50.2171 59.3433 52.2731 59.3433 54.329 59.3433C54.559 59.3433 54.7683 59.3473 54.9143 59.0878C55.0614 58.8253 55.3546 58.922 55.5895 58.9545C55.8382 58.9881 55.8106 59.2062 55.8115 59.3828C55.8155 60.0074 55.7997 60.633 55.8185 61.2566C55.8283 61.6138 55.6556 61.7075 55.3388 61.7114C55.0012 61.7154 54.8512 61.5743 54.8749 61.2388C54.8828 61.1244 54.867 61.0079 54.8758 60.8935C54.9035 60.557 54.7584 60.4159 54.4169 60.4238C53.8582 60.4376 53.2986 60.4406 52.7399 60.4228C52.3747 60.4109 52.2513 60.554 52.2563 60.9152C52.2721 62.1811 52.2622 63.4471 52.2622 64.7131L52.2592 64.7121Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_252_27546">
                    <rect width="70" height="70" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div class="col-lg-3 mb-4">
            <h5><strong>QUICK LINKS</strong></h5>
            <ul class="footer-links">
              <li><a href="/our-fellows" style="font-size: var(--font-size-lg); text-decoration: underline !important;">Find our
                  fellows</a></li>
              <li><a href="/our-fellows" style="font-size: var(--font-size-lg); text-decoration: underline !important;">Fellow
                  Profiles</a></li>
              <li><a href="/network-of-excellence"
                  style="font-size: var(--font-size-lg); text-decoration: underline !important;">Networks of Excellence</a></li>
              <li><a href="/funding-and-training"
                  style="font-size: var(--font-size-lg); text-decoration: underline !important;">Funding and training
                  opportunities</a></li>
              <li><a href="/public-news" style="font-size: var(--font-size-lg); text-decoration: underline !important;">News</a>
              </li>
              <li><a href="/contact" style="font-size: var(--font-size-lg); text-decoration: underline !important;">Contact</a></li>
            </ul>
          </div>

          <div class="col-lg-3 mb-4">
            <h5><strong>EDCTP EUROPE</strong></h5>
            <p class="small" style="margin-bottom: 0; font-size: var(--font-size-lg);">Laan van Nieuw Oost-Indië 133 F, 2593 BM</p>
            <p class="small" style="font-size: var(--font-size-lg);">The Hague, The Netherlands</p>
            <p class="small mt-3" style="font-size: var(--font-size-lg);">T: +31 70 344 0800</p>
            <div class="social-links-footer mt-3">
              <a href="https://x.com/edctp" class="social-link-footer"><i class="bi bi-twitter"></i></a>
              <a href="https://www.linkedin.com/company/global-health-edctp3/" class="social-link-footer"><i
                  class="bi bi-linkedin"></i></a>
              <a href="https://www.youtube.com/@edctpmedia" class="social-link-footer"><i class="bi bi-youtube"></i></a>
            </div>
          </div>

          <div class="col-lg-3 mb-4">
            <h5><strong>EDCTP AFRICA</strong></h5>
            <p class="small" style="margin-bottom: 0; font-size: var(--font-size-lg);">P.O. Box 19070, Tygerberg 7505</p>
            <p class="small" style="margin-bottom: 0; font-size: var(--font-size-lg);">Cape Town, South Africa</p>
            <p class="small mt-3" style="margin-bottom: 0; font-size: var(--font-size-lg);">T: +27 21 938 0609</p>
            <p class="small" style="font-size: var(--font-size-lg);">F: +27 21 938 0569</p>
          </div>
        </div>
      </div>
    </footer>
    <footer class="bg-white text-black py-5 funding-footer">
      <div class="container">
        <div class="row align-items-center g-4 pt-4 pb-4">
          <div class="col-12 col-lg-3">
            <div class="row align-items-center funding-footer-logo-row">
              <div class="col-auto d-flex align-items-center funding-footer-logo-cell">
                <!-- EDCTP3 logo -->
                <img class="img-fluid funding-footer-image funding-footer-image--edctp"
                  src="/edctp3-logo.png"
                  alt="Global Health EDCTP3 logo">
              </div>
              <div class="col-auto d-flex align-items-center funding-footer-logo-cell">
                <!-- EU logo -->
                <img class="img-fluid funding-footer-image funding-footer-image--eu"
                  src="/eu-logo.png"
                  alt="Co-funded by the European Union">
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <p class="funding-footer-grant-copy">This project (Grant Agreement No 101268430) is supported by the Global Health EDCTP3 Joint Undertaking and its members.</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-9 funding-footer-copy">
            <h6 class="funding-footer-heading">Funding acknowledgement</h6>
            <p>
              This platform is currently supported by the Global Health EDCTP3 Joint Undertaking. Previous development
              and support were funded by the National Institute for Health Research (NIHR) using UK Aid from the UK
              Government to support global health research, as part of the EDCTP2 programme supported by the European
              Union.
            </p>
            <p class="mb-0">
              The views and opinions expressed on this platform are those of the authors and do not necessarily reflect
              those of the Global Health EDCTP3 Joint Undertaking, the European Union, NIHR, or the UK Government.
            </p>
          </div>
        </div>
      </div>
    </footer>

    <!-- Login Modal -->
    <div v-if="showLoginModal" class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);"
      @click.self="showLoginModal = false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <a href="/" class="app-brand-link gap-2">
                <span class="app-brand-logo demo">
                  <img src="/logo.svg" alt="EDCTP Logo">
                </span>
              </a>
            </h5>
            <button type="button" class="btn-close" @click="showLoginModal = false" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div style="text-align: center; margin-bottom: 2rem;">
              <h4 class="mb-2">Welcome to EDCTP Alumni network!</h4>
              <p class="mb-4">This area of the platform is restricted to EDCTP Fellows and Regional Networks of
                Excellence.</p>
            </div>


            <!-- Error Message Display -->
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>

            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="username" class="form-label">Email</label>
                <input type="email" class="form-control" id="username" v-model="form.username"
                  :class="{ 'is-invalid': errors.username }" placeholder="Enter your email" autofocus required />
                <div class="invalid-feedback" v-if="errors.username">
                  {{ errors.username }}
                </div>
              </div>

              <div class="mb-3 form-password-toggle">
                <label class="form-label" for="password">Password</label>
                <div class="input-group input-group-merge">
                  <input :type="showPassword ? 'text' : 'password'" id="password" class="form-control"
                    v-model="form.password" :class="{ 'is-invalid': errors.password }"
                    placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" required />
                  <span class="input-group-text cursor-pointer" @click="showPassword = !showPassword">
                    <i class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </span>
                  <div class="invalid-feedback" v-if="errors.password">
                    {{ errors.password }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="remember-me" v-model="form.remember_me" />
                  <label class="form-check-label" for="remember-me">Remember Me</label>
                </div>
                <div class="text-end">
                  <a href="#" class="text-muted" @click="showLoginModal = false; $router.push('/forgot-password')">
                    <small>Forgot Password?</small>
                  </a>
                </div>
              </div>

              <div class="mb-3">
                <button class="btn btn-primary d-grid w-100" type="submit" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loading ? 'Signing in...' : 'Sign in' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PublicLayout',

  data() {
    return {
      showLoginModal: false,
      form: {
        username: '',
        password: '',
        remember_me: false
      },
      showPassword: false,
      errors: {},
      errorMessage: ''
    }
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'loading', 'error']),

    appName() {
      return process.env.VUE_APP_NAME || 'EDCTP Admin'
    },

    currentYear() {
      return new Date().getFullYear()
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'login']),

    async handleLogout() {
      try {
        await this.logout()
        this.$router.push('/')
      } catch (error) {
        console.error('Logout failed:', error)
      }
    },

    async handleLogin() {
      this.errors = {}
      this.errorMessage = ''
      try {
        const result = await this.login(this.form)
        if (result.success) {
          // Login successful - close modal and redirect
          this.showLoginModal = false
          this.resetForm()
          console.log('Login successful')
          // Redirect to dashboard or appropriate page
          this.$router.push('/my-profile')
        } else {
          // Show error message
          this.errorMessage = result.message || 'Login failed'
        }
      } catch (error) {
        console.error('Login error:', error)
        // Handle different types of errors
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        } else if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message
        } else if (error.message) {
          this.errorMessage = error.message
        } else {
          this.errorMessage = 'Login failed. Please try again.'
        }
      }
    },

    resetForm() {
      this.form = {
        username: '',
        password: '',
        remember_me: false
      }
      this.showPassword = false
      this.errors = {}
      this.errorMessage = ''
    }
  },

  watch: {
    // Clear error message when user starts typing
    'form.username'() {
      this.errorMessage = ''
      this.errors = {}
    },
    'form.password'() {
      this.errorMessage = ''
      this.errors = {}
    },
    // Reset form when modal is closed
    showLoginModal(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script>

<style scoped>
.nav-item {
  padding: 0px 15px;
  color: #000 !important;
  font-size: var(--font-size-base);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
  letter-spacing: 0.16px;
}

.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

.navbar-brand {
  color: #009CAD !important;
  font-size: var(--font-size-xl);
}

.nav-link {
  color: #000 !important;
  font-size: var(--font-size-base);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
  letter-spacing: 0.16px;
}

.router-link-active {
  border-bottom: solid 2px #009CAD !important;
  color: #000 !important;
  font-size: var(--font-size-base);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
  letter-spacing: 0.16px;
}

.footer {
  margin-top: auto;
}

.btn-link {
  border: none;
  padding: 0.5rem 1rem;
  text-decoration: none;
}

.navbar-eu-logo {
  height: 52px;
  width: auto;
  object-fit: contain;
  margin-right: 1rem;
}

/* Modal Styles */
.modal {
  z-index: 1050;
}

.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.modal-title {
  color: #2c3e50;
  font-weight: var(--font-weight-semibold);
  margin: 0;
}

.modal-body {
  padding: 2rem 1.5rem;
}

.app-brand-text {
  color: #009CAD;
  font-size: var(--font-size-xl);
}

.cursor-pointer {
  cursor: pointer;
}

.form-password-toggle .input-group-text:hover {
  background-color: #f8f9fa;
}

.alert {
  border-radius: 0.375rem;
  font-size: var(--font-size-sm);
}

.alert-danger {
  background-color: #ffe6e6;
  border-color: #ffcccc;
  color: #d63031;
}

.is-invalid {
  border-color: #ff3e1d;
}

.is-invalid:focus {
  border-color: #ff3e1d;
  box-shadow: 0 0 0 0.2rem rgba(255, 62, 29, 0.25);
}

.invalid-feedback {
  color: #ff3e1d;
  font-size: var(--font-size-sm);
  margin-top: 0.25rem;
}

.btn-close {
  background: none;
  border: none;
  font-size: var(--font-size-lg);
  opacity: 0.6;
}

.btn-close:hover {
  opacity: 1;
}

.btn-primary {
  background-color: #009CAD;
  border-color: #009CAD;
}

.btn-primary:hover {
  background-color: #007b8a;
  border-color: #007b8a;
}

.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
}

.social-links-footer {
  display: flex;
  gap: 0.75rem;
}

.social-link-footer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link-footer:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  transform: translateY(-2px);
}

.footer-section {
  background-color: #255153 !important;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: var(--font-size-sm);
}

.footer-links a:hover {
  color: white;
}

.funding-footer {
  color: #255153;
}

.funding-footer-logo-row {
  --bs-gutter-x: 0.75rem;
  --bs-gutter-y: 0.75rem;
}

.funding-footer-logo-cell {
  min-height: 120px;
  aspect-ratio: 1 / 1;
  justify-content: flex-start;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  overflow: hidden;
}

.funding-footer-image {
  height: 100px;
  max-width: none;
  object-fit: fill;
  object-position: center center;
  display: block;
}

.funding-footer-grant-copy {
  margin-bottom: 0;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-tight);
  color: #255153;
  text-align: justify;
  text-justify: inter-word;
}

.funding-footer-copy {
  text-align: left;
  color: #255153;
}

.funding-footer-copy p {
  text-align: justify;
  text-justify: inter-word;
}

.funding-footer-heading {
  font-weight: var(--font-weight-bold);
  margin-bottom: 0.75rem;
}

@media (max-width: 991.98px) {
  .navbar-eu-logo {
    height: 44px;
    margin: 0.75rem 0;
  }

  .funding-footer-logo-cell {
    min-height: 110px;
    aspect-ratio: 1 / 1;
  }

  .funding-footer-grant-copy {
    text-align: justify;
  }

  .funding-footer-copy p {
    text-align: justify;
  }
}
</style>
